import './components/share'

import './scss/st10/styles.scss'
